'use client';
// -------------- assets -------------------- //
import ArrowIcon from '@/assets/icons/arrow.svg';
// -------------- styles -------------------- //
import { fetchSideBarData } from '@/apis/apiBestSeller';
import { formatURLStandard } from '@/utils/formatProductLink';
import { useEffect, useState } from 'react';
import styles from './SidebarAccordion.module.scss';
import { sendClickTrack, sendPv } from '@/tracks/32521';
import {
  BESTSELLERS_EVENT_NAMES,
  bestSellersBusinessLogger,
} from '@/utils/logger/instance/bestSellersBusinessLogger';

interface SidebarAccordionPropTypes {
  title: string;
  index: number;
  level: number;
  selected: number;
  isFirst: boolean;
  data: any;
  setSelected: (index: number) => void;
  handleFetch: (val: string) => void;
}
const SidebarAccordion = ({
  title,
  index,
  level,
  selected,
  isFirst,
  data,
  setSelected,
  handleFetch,
}: SidebarAccordionPropTypes) => {
  const [isOpen, setIsOpen] = useState(false);
  const [subCategoryData, setSubCategoryData] = useState([]);

  // -------------- handler function -------------------- //
  const handleClick = () => {
    // open or closes accordion
    setIsOpen(!isOpen);
    // setSelected to index
    setSelected(index);
    // handle fetch new best-seller data
    handleFetch(data?.sequenceId);
    // handle update secondary sidebar
    handleUpdateSideBar(data?.sequenceId);
    // m
    sendClickTrack.Activity_BestSellersHome_Tab({
      tabName: title || '-100',
      index,
      cateLevel: level || -100,
    });
  };
  // fetch sidebar data according to sequenceId
  async function handleUpdateSideBar(sequenceId: string) {
    const res = await fetchSideBarData({ sequenceId: sequenceId });
    if (res && res.code === '200') {
      const subCategoryData = res?.data?.data?.data || [];
      setSubCategoryData(subCategoryData);
    } else {
      bestSellersBusinessLogger({
        eventName: BESTSELLERS_EVENT_NAMES.SIDEBAR_LOAD_FAIL,
        message: {
          code: res.code,
        },
      });
    }
  }

  useEffect(() => {
    if (selected === index && !isFirst) {
      // open or closes accordion
      setIsOpen(true);
      // handle fetch new best-seller data
      handleFetch(data.sequenceId);
      // handle update secondary sidebar
      handleUpdateSideBar(data.sequenceId);
    }
  }, []);

  // -------------- return  -------------------- //
  return (
    <>
      <button
        className={styles.container}
        onClick={() => {
          handleClick();
          window.history.pushState({}, '', '/promo/best-seller');
          !isFirst &&
            sendClickTrack.Activity_BestSellersHome_Tab_Unfold_Click({
              tabName: title || '-100',
              index: index || -100,
              isunfold: '0',
            });
        }}
        disabled={selected === index && selected === 0}
      >
        <div
          className={`${styles.title} ${selected === index ? styles.titleBold : styles.titleNormal}`}
        >
          {title}
        </div>
        {!isFirst && <ArrowIcon className={` ${styles.arrowIcon} ${isOpen && styles.arrowOpen}`} />}
      </button>
      <div className={styles.subLinkContainer}>
        {isOpen &&
          subCategoryData &&
          subCategoryData.map((items: any, index: number) => {
            return (
              <a
                href={`/promo/best-seller/${formatURLStandard(items.title)}/${items.sequenceId}`}
                key={index}
                onClick={() =>
                  sendClickTrack.Activity_BestSellersHome_Tab_Unfold_Click({
                    tabName: items?.categoryTabName || '-100',
                    index: index || -100,
                    isunfold: '0',
                  })
                }
                className={styles.subcategoryLink}
              >
                {items?.categoryTabName}
              </a>
            );
          })}
      </div>
    </>
  );
};

export default SidebarAccordion;
